import React from 'react';
export var SiteConfigContext = /*#__PURE__*/React.createContext({
  siteConstants: {
    HUB_LINKS: []
  }
});
/**
 * This is the Site Configuration Provider context component
 * We're able to set all of the site specific constants here so throughout the app we can access this information
 */

export function SiteConfigProvider(_ref) {
  var children = _ref.children,
      _ref$siteConstants = _ref.siteConstants,
      siteConstants = _ref$siteConstants === void 0 ? {} : _ref$siteConstants,
      _ref$siteComponents = _ref.siteComponents,
      siteComponents = _ref$siteComponents === void 0 ? {} : _ref$siteComponents,
      _ref$featureToggles = _ref.featureToggles,
      featureToggles = _ref$featureToggles === void 0 ? {} : _ref$featureToggles;
  return /*#__PURE__*/React.createElement(SiteConfigContext.Provider, {
    value: {
      siteConstants: siteConstants,
      siteComponents: siteComponents
    }
  }, children);
}